module.exports = __webpack_public_path__ + "static/media/file-pdf.20137da0.svg";